var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"price"},[_vm._v("\n    开票金额："),_c('span',[_c('sub',[_vm._v("¥")]),_vm._v(_vm._s(_vm._f("NumFormat")(_vm.price)))])])}
var staticRenderFns = []

export { render, staticRenderFns }